'use es6';

import FailedToPublishMessage from 'conversations-visitor-message-history/publishing/FailedToPublishMessage';
import { connect } from 'react-redux';
import { republishMessage } from '../../../actions/PublishActions/republishMessage';
const mapDispatchToProps = {
  onRepublish: republishMessage
};
export default connect(null, mapDispatchToProps)(FailedToPublishMessage);